import { dataLayerSendEvent } from '@common/Utility/analytics-utils';
import { AE_GLOBAL, DELIVERY_CHARGES, DELIVERY_TYPES, PAYMENT_CURRENCY } from '@common/Utility/constants';
import { getProductDetailsAttributes } from '@common/Utility/insider-object-integration';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { getProductItemObject, getProductItemObjectEventFillersSelect } from '../EpharmacyAnalytics';

export const sendCartEvent = (cartDataInitial, referrerPage, tempSelectedAddress, userLocation) => {
  const grandTotal = cartDataInitial?.body?.total;
  const deliveryExpress =
    cartDataInitial?.body?.delivery_groups?.find((group) => group?.delivery_type === DELIVERY_TYPES?.EXPRESS)?.items ||
    [];
  const totalExpressQty = deliveryExpress?.length;
  const deliveryStandard =
    cartDataInitial?.body?.delivery_groups?.find((group) => group?.delivery_type === DELIVERY_TYPES?.STANDARD)?.items ||
    [];
  const totalStandardQty = deliveryStandard?.length;
  const expressDeliveryCharge =
    cartDataInitial?.body?.charges?.find((charge) => charge?.name === DELIVERY_CHARGES?.EXPRESS)?.value || 0;
  const standardDeliveryCharge =
    cartDataInitial?.body?.charges?.find((charge) => charge?.name === DELIVERY_CHARGES?.STANDARD)?.value || 0;
  const ecommerceItems =
    cartDataInitial?.body?.delivery_groups?.flatMap((group) =>
      group?.items?.map((item) => ({
        ...getProductItemObjectEventFillersSelect(item, group?.deliver_by_V2 || group?.deliver_by),
        quantity: parseFloat(item?.qty),
      })),
    ) || [];

  let deliveryType;
  if (deliveryExpress?.length) {
    deliveryType = AE_GLOBAL?.EXPRESS;
  }
  if (deliveryStandard?.length) {
    deliveryType = AE_GLOBAL?.STANDARD;
  }
  if (deliveryExpress?.length && deliveryStandard?.length) {
    deliveryType = AE_GLOBAL?.MIXED;
  }
  const cartEventData = {
    value: grandTotal || 0,
    delivery_type: deliveryType || null,
    referrer_page: referrerPage,
    total_quantity: totalExpressQty + totalStandardQty,
    total_express_quantity: totalExpressQty || 0,
    total_standard_quantity: totalStandardQty || 0,
    order_value_before_promotion: cartDataInitial?.body?.base_sub_total || 0,
    express_delivery_charge: expressDeliveryCharge || 0,
    standard_delivery_charge: standardDeliveryCharge || 0,
    screen_name: 'my cart',
    page_type: 'cart page',
    currency: 'AED',
    myaster_category: 'epharmacy',
    ecommerce: {
      items: ecommerceItems,
    },
    delivery_address_availability:
      Object.keys(tempSelectedAddress).length > 0 || Object.keys(userLocation?.locationItem).length > 0 ? true : false,
    is_cart_empty: cartDataInitial?.body?.delivery_groups?.length > 0 ? false : true,
  };
  dataLayerSendEvent('view_cart', cartEventData);
};

export const cartInfoUpdate = (cartDataInitial) => {
  const total = cartDataInitial?.total;
  const currency = cartDataInitial?.currency ? cartDataInitial?.currency : PAYMENT_CURRENCY;
  cartDataInitial?.delivery_groups?.forEach((group) => {
     const item = group?.items?.map((productItem) => {
      const productSalePrice = productItem?.sale_price
        ? parseFloat(productItem?.sale_price)
        : parseFloat(productItem?.base_price);
      return {
        ...getProductItemObject(productItem),
        quantity: productItem?.qty,
        subtotal: productItem?.qty * productSalePrice,
        ...getProductDetailsAttributes(productItem?.item, 'Pharmacy'),
      };
    });

    dataLayerSendEvent('cart_items_update', {
      currency,
      value: total,
      ecommerce: { items: item },
      coupon: null,
      coupon_code_value: 0,
      shipping_cost: cartDataInitial?.charges?.reduce((sum, item) => sum + item.value, 0),
    });
  });
};

//TODO: keeping getViewCartEvent for ref
// export const  getViewCartEvent = (response) => {
//   const grandAmount = response?.total_segments?.find((item) => item?.title === 'Grand Total')?.value;
//   const deliveryExpress = response?.items?.filter((item) => item?.product?.express === true);
//   const totalExpressQty = deliveryExpress?.reduce((sum, item) => sum + item?.qty, 0);
//   const deliveryStandard = response?.items?.filter((item) => item?.product?.express === false);
//   const totalStandardQty = deliveryStandard?.reduce((sum, item) => sum + item?.qty, 0);

//   let deliveryType;
//   if (deliveryExpress?.length) {
//     deliveryType = 'express';
//   }
//   if (deliveryStandard?.length) {
//     deliveryType = 'standard';
//   }
//   if (deliveryExpress?.length && deliveryStandard?.length) {
//     deliveryType = 'mixed';
//   }

//   const ecommerceItems = response?.items?.map((item) => {
//     return {
//       ...getProductItemObjectEventFillersSelect(item?.product),
//       quantity: parseFloat(item?.qty),
//     };
//   });

//   const expressDeliveryCharge = response?.charges?.find(
//     (item) => item?.displayText === 'Express Delivery Charge',
//   )?.value;
//   const standardDeliveryCharge = response?.charges?.find(
//     (item) => item?.displayText === 'Standard Delivery Charge',
//   )?.value;
//   const params = {
//     screen_name: 'my cart',
//     page_type: 'cart page',
//     referrer_page: props?.referrerPage,
//     myaster_category: 'epharmacy',
//     ecommerce: {
//       items: ecommerceItems,
//     },
//     delivery_type: deliveryType || null,
//     total_quantity: totalExpressQty + totalStandardQty,
//     total_express_quantity: totalExpressQty || 0,
//     total_standard_quantity: totalStandardQty || 0,
//     order_value_before_promotion: response?.subTotalSpecialPrice || 0,
//     express_delivery_charge: expressDeliveryCharge || 0,
//     standard_delivery_charge: standardDeliveryCharge || 0,
//     delivery_address_availability:
//       Object.keys(tempSelectedAddress).length > 0 || userLocation?.locationItem ? true : false,
//     value: grandAmount,
//     currency: 'AED',
//     is_cart_empty: response?.items?.length > 0 ? false : true,
//   };
//   dataLayerSendEvent('view_cart', params);
// };

export const handleBannerEventsClicked = (eventType, bannersData) => {
  const bannerDetails = {
    screen_name: 'my cart',
    page_type: 'cart page',
    myaster_category: 'epharmacy',
    coupon_name: null,
    banner_name: `${eventType} cart banner`,
    banner_url: bannersData?.linkWeb,
    banner_id: bannersData?.banner_id,
    section_name: '',
    banner_page_slot: eventType,
    banner_position: eventType === 'top' ? 1 : 2,
  };

  dataLayerSendEvent(handleBannerEvent, bannerDetails);
};

export const cartPromoBannerImpression = (bannersData) => {
  const bannerDetails = {
    screen_name: 'my cart',
    page_type: 'cart page',
    myaster_category: 'epharmacy',
    coupon_name: null,
    banner_name: 'top cart banner',
    banner_url: bannersData?.top ? bannersData.top.linkWeb : bannersData?.bottom?.linkWeb,
    banner_id: bannersData?.top ? bannersData?.top?.banner_id : bannersData.bottom.banner_id,
    section_name: '',
    banner_page_slot: bannersData?.top ? 'top' : 'bottom',
    banner_position: bannersData?.top ? 1 : 2,
  };

  dataLayerSendEvent('cart_promo_banner_impression', bannerDetails);
};
